const de = {
  layout: {
    cos_button: {
      phone: 'Telefon',
      update_phone_number_message: 'Telefonnummer wurde erfolgreich aktualisiert!'
    },
    time: {
      days: 'Tage',
      hours: 'Std',
      mins: 'Min',
      secs: 'Sek',
      starts: 'Startet',
      starts_immediately: 'Startet sofort'
    },
    field: {
      host: 'Moderator'
    },
    copy: 'Kopieren'
  },
  validations: {
    email: 'muss eine gültige E-Mail-Adresse sein',
    phone: 'ist nicht gültig',
    required_field: 'ist ein Pflichtfeld'
  },
  mailer: {
    need_help: 'Hilfe gefällig?',
    stop_reminders: 'Keine Erinnerungen mehr erhalten',
    cancel_registration: 'Registrierung abbrechen',
    report_abuse: 'Missbrauch melden'
  },
  datetime: {
    no_sessions: 'Keine Sitzungen verfügbar',
    empty_label: 'Datum/Uhrzeit'
  },
  errors: {
    verification_failed: 'Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    session_unavailable:
      'Der von Ihnen gewählte Zeitpunkt ist nicht mehr verfügbar. Bitte wählen Sie einen anderen Termin.',
    challenge_email_mismatch:
      'Bitte registrieren Sie sich mit derselben E-Mail-Adresse, die Sie für die Veranstaltung verwendet haben.'
  }
}

export default de
